<template>
    <div>
        <v-dialog v-model="showAddNewOrder" v-if="showAddNewOrder" persistent>
            <order-purchase-new @onClose="
                showAddNewOrder = false;
            $refs.crud.refresh()" v-if="showAddNewOrder"></order-purchase-new>
        </v-dialog>

        <div v-if="dialogEdit">
            <v-dialog v-model="dialogEdit" persistent width="100%">
                <v-card class="rounded-xl">
                    <order-purchase-edit @onClose="
                        dialogEdit = false;
                    $refs.crud.refresh();
                    " :value="parentID" @download="pdfOrder($event)" :typeOrder="1" :order="{}" :viewLoad="true"
                        :isEditableOC="IsEditOrder" />
                </v-card>
            </v-dialog>
        </div>

        <v-row>
            <v-col md="12" lg="12" sm="12" class="pb-1">
                <s-crud excel add @add="showAddNewOrder = true" sortable :view="item.OrdStatus != 3" searchInput
                    :remove="item.OrdStatus != 4 && item.OrdStatus != 6 && item.OrdStatus != 5 && item.OrdStatus != 7"
                    add-no-function :pdf="item.OrdStatus == 5" @pdf="pdf($event)" delete-no-function
                    @delete="deleteEvent($event)" :config="config" @save="save($event)" ref="crud"
                    @edit="dialogEdit = true" :filter="filter" :edit="item.OrdStatus == 3 || item.IsEditOrder == 1"
                    title="Orden de Compra" @rowSelected="selectRows($event)" sync @sync="syncOrder()">
                    <!-- btnsearch -->
                    <template v-slot:OrdTotal="{ row }">
                        <v-container fluid>
                            <v-row justify="center">
                                <v-col>
                                    {{ row.OrdTotal >= 1000 ? (row.OrdTotal | numberDefault) : (row.OrdTotal |
                                        numberDefault) }}
                                </v-col>
                            </v-row>
                        </v-container>
                    </template>
                    <template v-slot:filter>
                        <v-container fluid>
                            <v-row dense>
                                <v-col v-if="$fun.isAdmin()" lg="3" md="4">
                                    <s-select label="Usuario" placeholder="Digite Usuario" autocomplete clearable
                                        item-text="NtpFullName" v-model="filter.UsrID" item-value="UsrID"
                                        :items="itemsUsers" @input="selectedUsrID($event)"></s-select>
                                </v-col>
                                <v-col lg="3" md="4" cols="12" v-if="$fun.isLevelArea()">
                                    <s-select-area-allow label="Area" v-model="filter.AreID"></s-select-area-allow>
                                </v-col>
                                <v-col lg="3" md="4" cols="12">
                                    <s-provider v-model="filter.SupCode" />
                                </v-col>
                                <v-col lg="2" md="3" cols="12">
                                    <s-date label="Fecha Inicio" :clearable="clearableFilter"
                                        v-model="filter.BeginDate" />
                                </v-col>
                                <v-col lg="2" md="3" cols="12">
                                    <s-date label="Fecha Fin" :clearable="clearableFilter" v-model="filter.EndDate" />
                                </v-col>
                                <v-col lg="2" md="3" cols="12">
                                    <s-select-definition clearable label="Estados" :def="1151"
                                        v-model="filter.OrdStatus" />
                                </v-col>
                            </v-row>
                        </v-container>
                    </template>
                    <template v-slot:OrdStatusName="{ row }">
                        <div class="d-flex align-center justify-center">
                            <v-chip x-small dense
                                :color="row.OrdStatus == 4 ? 'primary' : row.OrdStatus == 3 ? 'error' : row.OrdStatus == 6 ? 'error' : row.OrdStatus == 9 ? 'error' : ''"
                                class="mr-2 pa-2 font-weight-semibold px-1 text-uppercase">
                                {{ row.OrdStatusName }}
                            </v-chip>
                            <v-btn v-if="row.OrdStatus == 5 && row.UsrCreateID == $fun.getUserID()" icon small
                                color="error" title="Cerrar Orden" @click="closeOrderEvent(row)">
                                <v-icon>mdi-lock-outline</v-icon>
                            </v-btn>
                        </div>
                    </template>
                </s-crud>
            </v-col>

            <v-col class="mt-0 pt-0" lg="12" cols="12" v-if="item">
                <ApprovalLevelsDocument :DocEntry="item.OrdID" :TypeObject="2" :showButtonClose="false" />
            </v-col>

            <!-- <v-col class="mt-0 pt-0" lg="12" cols="12" v-if="item && item.TypeOrder == 3">
                <ServiceOrderActivity :order="item" />
            </v-col> -->
        </v-row>


        <v-dialog v-model="dialogPdf" v-if="dialogPdf" max-width="755px">
            <order-pdf :value="parentID" @close="dialogPdf = false"></order-pdf>
        </v-dialog>

        <v-dialog v-model="dialogDeleteOptions" max-width="500px" persistent>
            <v-card>
                <v-card-title class="headline">
                    Anular Orden de Compra
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <p class="text-body-1 mb-4">
                                    Seleccione el tipo de anulación que desea realizar:
                                </p>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6" class="py-2">
                                <v-btn block large color="error" @click="confirmDelete(6)">
                                    <v-icon left>mdi-close-circle</v-icon>
                                    Anular Totalmente
                                </v-btn>
                            </v-col>
                            <v-col cols="6" class="py-2">
                                <v-btn block large color="warning" @click="confirmDelete(0)">
                                    <v-icon left>mdi-lock-open-variant</v-icon>
                                    Liberar Requerimiento
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey" text @click="dialogDeleteOptions = false">
                        Cancelar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- 
    <v-row>
       {{ this.filter  }} 
      </v-row> -->
    </div>
</template>

<script>
import _sPermit from "@/services/Logistics/PermitService";
import _sOrderPurchase from "@/services/Logistics/OrderPurchaseService";
import OrderPurchaseEdit from "@/views/Logistics/OrderPurchase/OrderPurchaseEdit";
import OrderPurchaseNew from "@/views/Logistics/OrderPurchase/OrderPurchaseNew";
import ApprovalLevelsDocument from "@/views/Security/Circuit/Levels/ApprovalLevelsDocument";
import OrderPdf from "./OrderPdf.vue";
import ServiceOrderActivity from "./ServiceOrderActivity.vue";

export default {
    components: { OrderPurchaseEdit, ApprovalLevelsDocument, OrderPurchaseNew, OrderPdf, ServiceOrderActivity },

    data: () => ({
        dialogPdf: false,
        clearableFilter: true,
        //NEW ORDER
        arePermiss: [],
        areID: null,
        itemsUsers: [],
        showAddNewOrder: false,
        //
        item: {},
        dialogEdit: false,
        disabledRate: false,
        numberDefault: 0,
        IsEditOrder: false,
        dialogDeleteOptions: false,
        selectedItemToDelete: null,
        filter: {
            TypeOrder: 0,
            BeginDate: null,
            EndDate: null,
            UsrID: null,
            SupCode: null,
            AreID: null,
            OrdStatus: null,
        },
        config: {
            model: {
                OrdID: "ID",
                OrdDate: "date",
                OrdStatusName: "",
                OrdStatus: "",
                SecUpdate: "date",
                OrdTotal: "",
            },
            service: _sOrderPurchase,
            headers: [
                { text: "ID", value: "OrdID", sortable: false },
                { text: "Documento", value: "OrdDocumentNumber" },
                { text: "Tipo", value: "TypeOrderName", width: 100 },
                { text: "Fecha", value: "OrdDate" },
                { text: "Orden", value: "OrdDocNum" },
                // { text: "Area", value: "AreName", sortable: false },
                { text: "Total", value: "OrdTotal" },
                { text: "Proveedor", value: "SupName" },
                { text: "Usuario", value: "NtpFullName" },
                { text: "Fecha Act.", value: "SecUpdate" },
                { text: "Estado", value: "OrdStatusName", sortable: false, align: "center" },
            ],
        },
    }),
    watch: {
        filter() {

        }
    },
    created() {
        this.filter.UsrID = parseInt(this.$fun.getUserID());
        var objPers = {};
        //AreasAllow this.$fun.isAdmin() ? null : 
        // console.log("this.$fun.getSecurity()", this.$fun.getSecurity());
        if (this.$fun.isAdmin()) {

            objPers.AreID = this.areID;

            _sPermit.users(objPers, this.$fun.getUserID()).then((r) => {
                this.itemsUsers = r.data;
                this.filter.UsrID = parseInt(this.$fun.getUserID());
            });

        }

        if (this.$fun.isLevelArea()) {
            this.arePermiss = this.$fun.getSecurity().AreasAllow;

            this.filter.AreID = this.arePermiss[0].AreID;
            this.clearableFilter = false;
            this.filter.UsrID = null;
        }


    },
    mounted() {

    },

    methods: {
        syncOrder() {
            if (this.item.OrdStatus == 5) {
                console.log("syncOrder", JSON.parse(JSON.stringify({ item: this.item })));
                _sOrderPurchase.setStatus(this.item, this.$fun.getUserID()).then((r) => {
                    console.log(JSON.parse(JSON.stringify({ r })));


                    this.$refs.crud.refresh();
                    this.$fun.alert("Sincronizado Correctamente", "success");
                });
            }
        },
        selectedUsrID(item) {

        },
        pdf(item) {
            console.log("verificando archivo de impresion");
            console.log(item);
            this.dialogPdf = true;

            // _sOrderPurchase.PDF(item, this.$fun.getUserID()).then((r) => {
            //   this.$fun.downloadFile(r.data, this.$const.TypeFile.PDF, "Orden_compra");
            // });
        },

        deleteEvent(item) {
            console.log("Anular Orden de Compra", item);
            this.selectedItemToDelete = item;
            this.dialogDeleteOptions = true;
        },

        confirmDelete(status) {
            const item = this.selectedItemToDelete;
            const message = status === 6
                ? "¿Está seguro de anular totalmente la Orden de Compra?"
                : "¿Está seguro de liberar el requerimiento?";

            this.$fun.alert(message, "question").then((r) => {
                if (r.value) {
                    item.OrdStatus = status;
                    item.UsrUpdateID = this.$fun.getUserID();
                    _sOrderPurchase.setStatus(item, this.$fun.getUserID()).then((r) => {
                        this.$refs.crud.refresh();
                        const successMessage = status === 6
                            ? "Anulado Correctamente"
                            : "Requerimiento Liberado Correctamente";
                        this.$fun.alert(successMessage, "success");
                        this.dialogDeleteOptions = false;
                        this.selectedItemToDelete = null;
                    }).catch((error) => {
                        console.error("Error al actualizar estado:", error);
                        this.$fun.alert("Error al procesar la solicitud", "error");
                    });
                }
            });
        },

        closeOrderEvent(item) {
            this.$fun.alert("¿Está seguro de cerrar la Orden de Compra?", "question").then((r) => {
                if (r.value) {
                    item.OrdStatus = 9;
                    item.UsrUpdateID = this.$fun.getUserID();
                    _sOrderPurchase.closeOrder(item, this.$fun.getUserID()).then(() => {
                        this.$refs.crud.refresh();
                        this.$fun.alert("Orden de Compra Cerrada Correctamente", "success");
                    }).catch((error) => {
                        console.error("Error al cerrar la Orden:", error);
                        this.$fun.alert("Error al cerrar la Orden de Compra", "error");
                    });
                }
            });
        },

        selectRows(items) {
            // console.log("items", JSON.parse(JSON.stringify(items)));
            this.IsEditOrder = false;
            if (items.length > 0) {
                // this.filter.OrdID=items[0].OrdID
                this.parentID = items[0].OrdID;
                this.item = items[0];
                this.IsEditOrder = items[0].OrdStatus == 3 || items[0].IsEditOrder == 1;
                // console.log("🚀 ~ file: Orders.vue ~ line 196 ~ selectRows ~ this.item", this.item);
            } else {
                this.parentID = null
                this.item = {};
            };
        },
        pdfOrder(item) {
            this.dialogPdf = true;
        },
    },
};
</script>
